var render = function render(){var _vm=this,_c=_vm._self._c;return _c('scroll-bar',[_c('el-menu',{attrs:{"mode":"vertical","show-timeout":200,"default-active":_vm.$route.path,"collapse":_vm.isCollapse}},[_c('sidebar-item',{attrs:{"routes":_vm.routes}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }